module.exports = __webpack_public_path__ + "static/media/Penelope.e3445485.jpg";